<template>
  <div>

    <div class="row">
      <div class="col-5">
        <div class="card border-card shadow p-2">
          <p v-if="typology_name">
            {{ __("views.PeopleSkills.typologyCoverAgeRatePrefix") }} "{{ typology_name }}" {{ __("views.PeopleSkills.typologyCoverAgeRateOf") }}:
          </p>
          <p v-else>{{ __("views.PeopleSkills.positionCoverAgeRate") }}:</p>
          <p>{{ selectedRole }}</p>
          <p class="text-right">{{ positionCoverRate }} %</p>
        </div>
      </div>
      <div class="col-7" v-if="show_select">
        <label>{{ __("misc.select_a_role") }}:</label>
        <div class="d-flex">
          <select class="form-control" v-model="role">
            <option>---</option>
            <option v-for="role in roles" :value="role.id" :key="role.id">
              {{ role.name }}
            </option>
          </select>
          <button class="btn btn--blue ml-2" @click="reloadBenchmark()">
            {{ __("misc.launch_simulation") }}
          </button>
        </div>
        <div class="my-3" v-if="showLoading">
          {{ __("misc.loading") }} <i class="fas fa-spinner fa-pulse"></i>
        </div>
      </div>
    </div>
    <br />
    <hr>
    <section>
      <div class="row">
        <div class="col-12">
          <horizontal-bar-pnp style="height: 500px" ref="horizontal_bar_benchmark_skills" :step_size="1"
            title_text="Simulazione" :range="this.range"></horizontal-bar-pnp>
        </div>
        <div class="col-12">
          <br>
          <hr>
          <div class="row">
            <div class="col-12">
              {{ __("views.PeopleSkills.list") }}<br>
            </div>
          </div>
          <table class="table table-condensed">
            <thead>
              <tr>
                <th>Skill</th>
                <th>{{ __("forms.PeopleSkills.level_expected") }}</th>
                <th>{{ __("forms.PeopleSkills.level_real") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in skillsTable" :key="i">
                <td>{{ row.skillName }}</td>
                <td>{{ row.skillRoleLevel }}</td>
                <td>{{ row.skillPersonLevel }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <section></section>
  </div>
</template>

<script>
import { range } from 'lodash';

export default {
  data() {
    return {
      role: null,
      selectedRole: null,
      skillsTable: [],
      positionCoverRate: 0,
      showLoading: false,
    };
  },

  methods: {
    reloadBenchmark() {
      this.populateSkillTable(this.role);
    },
    populateSkillTable(custom_role) {

      if (this.roles.find(el => el.id === custom_role)) {
        this.selectedRole = this.roles.find(el => el.id === custom_role).name;
      } else {
        this.selectedRole = "attuale";
      }

      this.showLoading = true;

      axios
        .get("/simulation-skills-for-person/" + this.person + "/person", {
          params: {
            custom_role: custom_role,
            ...(this.typology_id ? { typology_id: this.typology_id } : {}),
          },
        })
        .then((response) => {
          
          this.skillsTable = response.data.tableRoleSkills;
          this.positionCoverRate = response.data.positionCoverRate;
          this.$refs.horizontal_bar_benchmark_skills.drawBarsGraph(
            response.data.horizontalGraphSettings
          );
          this.showLoading = false;
        })
        .catch(function (error) {
          alert(error);
          this.showLoading = false;
        });
    },
  },
  mounted() {
    this.role = this.role_default;
    this.populateSkillTable(this.role);
  },
  props: {
    person: {
      type: Number,
      required: true,
    },
    roles: {
      type: Array,
      required: true,
    },
    role_default: {
      type: Number,
      required: false,
      default: null,
    },
    show_select: {
      type: Boolean,
      required: false,
      default: true,
    },
    range: {
      type: Object,
      required: false,
      default() {
        return {
          min: 0,
          max: 3,
        };
      },
    },
    typology_id: {
      type: Number,
      default: null,
    },
    typology_name: {
      type: String,
      default: null,
    },
  },
};
</script>
<style></style>